export default "__VITE_ASSET__Cb4NZpQA__"